import React, { useEffect, useRef, useState } from "react";
import { Mic, Square } from "lucide-react";
import { toast } from "sonner";

// Browser-native speech-to-text (Web Speech API). Appends final transcripts via onText.
export default function MicButton({ onText, testid = "mic-btn", label = "Dictate" }) {
  const [on, setOn] = useState(false);
  const recRef = useRef(null);

  useEffect(() => {
    const SR = window.SpeechRecognition || window.webkitSpeechRecognition;
    if (!SR) return;
    const r = new SR();
    r.continuous = true;
    r.interimResults = false;
    r.lang = "en-US";
    r.onresult = (e) => {
      let t = "";
      for (let i = e.resultIndex; i < e.results.length; i++) {
        if (e.results[i].isFinal) t += e.results[i][0].transcript;
      }
      if (t.trim()) onText(t.trim());
    };
    r.onend = () => setOn(false);
    r.onerror = () => setOn(false);
    recRef.current = r;
    return () => { try { r.stop(); } catch (_) { /* already stopped */ } };
    // onText is stable via functional setState in callers
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const toggle = () => {
    const r = recRef.current;
    if (!r) { toast.error("Speech-to-text needs Chrome or Edge on this device."); return; }
    if (on) { r.stop(); setOn(false); }
    else { try { r.start(); setOn(true); } catch (_) { /* already started */ } }
  };

  return (
    <button type="button" onClick={toggle} data-testid={testid}
      className={`flex items-center gap-1.5 rounded-full border px-3 py-1.5 text-xs font-semibold transition-colors ${on ? "border-red-400 bg-red-50 text-red-600 animate-pulse" : "border-slate-300 text-slate-600 hover:bg-slate-50"}`}>
      {on ? <Square size={13} /> : <Mic size={14} />} {on ? "Listening… tap to stop" : label}
    </button>
  );
}
